import * as Yup from 'yup'

export const CreateSectorSchema = Yup.object({
  name: Yup.string().trim().required('Required')
})
